import { convertToError, useGetMeQuery } from 'API/BaseApi';
import React, { useEffect } from 'react';
import { useGetUserType } from './hooks/useGetUserType';
import { eAccessControlUserType } from 'ui-toolkit/enums/eAccessControlUserType';
import { ErrorMessage } from 'ui-toolkit/components/ErrorMessage/ErrorMessage';
import { BodyText } from 'ui-toolkit/components/Typography/basicTypography';
import { NavigationItem } from 'ui-toolkit/components/Navigation/NavigationItem';
import { SpruceHelpInlineLink } from 'ui-toolkit/components/Navigation/SpruceHelpInlineLink';
import { useGetMyTokenData } from './hooks/useGetMyTokenData';
import { useGetConfigQuery } from 'API/applicationConfig/ApplicationConfigAPI';
import type { FCWithChildren } from '../../types/FCWithChildren';

export const AccessControlRequired: FCWithChildren = ({ children }) => {
  const { data, isError, error, isLoading } = useGetMeQuery();
  const tokenData = useGetMyTokenData();
  const [hasFetchedFeatureFlags, setHasFetchedFeatureFlags] = React.useState(false);
  const { refetch } = useGetConfigQuery();

  const userType = useGetUserType();

  // This area makes sure a user is logged in.
  // So when a user is logged in, we want to fetch the feature flags
  useEffect(() => {
    if (!hasFetchedFeatureFlags && data && tokenData) {
      refetch();
      setHasFetchedFeatureFlags(true);
    }
  }, [refetch, hasFetchedFeatureFlags, data, tokenData]);

  const isAdmin = userType === eAccessControlUserType.Admin;

  return (
    <>
      {isError && (
        <>
          {!isAdmin ? (
            <ErrorMessage>
              <BodyText>
                Please email{' '}
                <NavigationItem isInline href={`mailto:support@spruce.co`} isActive={true} text={'support@spruce.co'} />{' '}
                for help
              </BodyText>
            </ErrorMessage>
          ) : (
            <ErrorMessage error={convertToError(error)}>
              <BodyText>
                There was an Access Control error!
                <br />
                Please <SpruceHelpInlineLink /> to submit a request for help
              </BodyText>
            </ErrorMessage>
          )}
        </>
      )}
      {!isLoading && children}
    </>
  );
};
